var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonnow3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 182,
    viewBox: "0 0 177 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 182
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 182,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-146.714 7.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.02,
    cy: 78.02,
    r: 78.02,
    transform: "translate(157.694 6.867)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.951,8.037a72.422,72.422,0,1,0,24.7,140.433,72.294,72.294,0,0,1,6.592-133.224A72.422,72.422,0,0,0,156.951,8.037ZM137.589,30.675c3.471.053,6.016,1.23,7.093,3.281,2.287,4.352-2.523,11.383-10.744,15.7s-16.743,4.295-19.029-.059,2.523-11.382,10.744-15.7a25.94,25.94,0,0,1,11.937-3.222ZM118.9,91.211a12.263,12.263,0,0,1,12.24,11.541,6.952,6.952,0,1,1-6.02,11.275,12.257,12.257,0,1,1-6.218-22.816Z",
    transform: "translate(78.762 4.429)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonnow3);
export default __webpack_public_path__ + "static/media/moonnow3.b567125798ce6b18aa81233ba9217bad.svg";
export { ForwardRef as ReactComponent };